import React from 'react';

/**
 * RecentActivity - Displays recent activity completions
 */
export const RecentActivity = ({ completions, t, formatRelativeTime }) => {
  return (
    <div className="card border rounded-3 mb-4">
      <div className="card-body p-4">
        <h3 className="h6 fw-bold mb-4">{t('curriculum.recent_activity.title')}</h3>

        {completions.length === 0 ? (
          <p className="text-muted small text-center py-3">{t('curriculum.recent_activity.no_activity')}</p>
        ) : (
          <div className="d-flex flex-column gap-3">
            {completions.map((completion) => (
              <div key={completion.id} className="d-flex align-items-start">
                <div
                  className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center me-3"
                  style={{ width: '32px', height: '32px', flexShrink: 0 }}
                >
                  <i className="bi bi-check-lg text-success"></i>
                </div>
                <div>
                  <p className="fw-medium small mb-1">
                    {t('curriculum.recent_activity.completed', { activity: completion.activity_name })}
                  </p>
                  <p className="text-muted small mb-0">
                    {formatRelativeTime(completion.completed_at)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;
